import { plural } from '@westhetics/ui'
import type { CatalogProcedure, TemplateState } from './api'

type Usage = CatalogProcedure['usage']

/** "42 clínicas · 57 procedimentos": o uso de um item da lista mestre. */
export function usageLabel(usage: Usage) {
  return `${plural(usage.clinicCount, 'clínica')} · ${plural(usage.procedureCount, 'procedimento')}`
}

/** O efeito real de arquivar um item do catálogo, com os números do uso (RN-ADM-74). */
export function archiveEffect(usage: Usage) {
  const lead = 'Ele sai da lista mestre e nenhuma clínica pode adicioná-lo.'
  const tail = 'Volta a qualquer momento.'
  if (usage.procedureCount === 0) return `${lead} Nenhuma clínica o usa hoje. ${tail}`
  const kept =
    usage.procedureCount === 1
      ? 'O procedimento da clínica que já o usa continua funcionando e emitindo os mesmos termos.'
      : `Os ${usage.procedureCount} procedimentos de ${plural(usage.clinicCount, 'clínica')} que já o usam continuam funcionando e emitindo os mesmos termos.`
  return `${lead} ${kept} ${tail}`
}

/** O que dizer, em texto secundário, de um documento que ainda não vale como termo publicado. */
export function templateStateNote(state: TemplateState): string | null {
  if (state === 'draft') return 'ainda sem versão publicada'
  if (state === 'archived') return 'arquivado'
  return null
}

/** Comparação sem caixa nem acento, como a API compara nomes e sinônimos (RN-ADM-71). */
export function fold(text: string) {
  return text.normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase()
}
